import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Neue Aktion erstellen',
  subtitle: 'Wie erhaelt der Kunde einen Gratisartikel?',
  validation: {
    required: 'Bitte einen Angebotstyp waehlen',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Gesamter Bestellwert',
      description: 'Z. B. 10% Rabatt auf die Bestellung, wenn Sie 20 {{currency}} ausgeben.',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Ausgewaehlte Artikel',
      description: 'Z. B. 10% Rabatt auf 12-Zoll-Pizzen.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Ausgewaehlte Artikel',
      description: 'Z. B. 1 {{currency}} Rabatt auf 12-Zoll-Pizzen.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Gesamter Bestellwert',
      description: 'Z. B. 1 {{currency}} Rabatt auf die Bestellung, wenn Sie 20 {{currency}} ausgeben.',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Kaufe 1, erhalte 1 gratis',
      description: 'Z. B. Kaufe 1 Pizza und erhalte eine zweite Pizza gratis. Die guenstigere Pizza wird rabattiert.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Kaufe 1, erhalte 1 zum halben Preis',
      description:
        'Z. B. Kaufe 1 Pizza und erhalte eine weitere zum halben Preis; die guenstigere Pizza wird rabattiert.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Durch Kauf eines weiteren Artikels',
      description: 'Z. B. Erhalten Sie ein Gratisgetraenk, wenn Sie ein Menue bestellen.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Durch festen {{currency}}-Bestellwert',
      description: 'Z. B. Erhalten Sie ein Gratisdessert, wenn Sie 20 {{currency}} ausgeben.',
    },
  },
};
